import React from 'react';

const SHORT_IDS = ["b1tnu2kqtW8", "BsuBlhYL_7w", "KqEtjiC8O8c", "Zbqcj4uL5kY", "Vi1_Q8YzuZ8"]

export const PromoVideos = () => (
  <div className="lf-shorts">
    {SHORT_IDS.map(id => (
      <div key={id} className="lf-short">
        <iframe
          src={`https://www.youtube.com/embed/${id}`}
          title="Lowfye50 short"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    ))}
  </div>
);
